"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var DataStore = (function () {
    function DataStore(json) {
        this.json = json;
    }
    DataStore.prototype.getAllStates = function () {
        var states = this.json.states;
        return states.map(function (s) {
            return { value: s.name, name: s.name };
        });
    };
    Object.defineProperty(DataStore.prototype, "programs", {
        get: function () {
            var json = this.json;
            var programs = [];
            programs = json.programs;
            return programs;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(DataStore.prototype, "gender", {
        get: function () {
            return [
                { value: "Male", name: "Male" },
                { value: "Female", name: "Female" }
            ];
        },
        enumerable: true,
        configurable: true
    });
    return DataStore;
}());
exports.DataStore = DataStore;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiRGF0YVN0b3JlLmpzIiwic291cmNlUm9vdCI6Ii4vIiwic291cmNlcyI6WyJwZGYvZGF0YS9EYXRhU3RvcmUudHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6Ijs7QUFFQTtJQUNJLG1CQUFvQixJQUFTO1FBQVQsU0FBSSxHQUFKLElBQUksQ0FBSztJQUFHLENBQUM7SUFFMUIsZ0NBQVksR0FBbkI7UUFDSSxJQUFNLE1BQU0sR0FBYyxJQUFJLENBQUMsSUFBSSxDQUFDLE1BQU0sQ0FBQTtRQUMxQyxPQUFPLE1BQU0sQ0FBQyxHQUFHLENBQUMsVUFBQyxDQUFDO1lBQ2hCLE9BQU8sRUFBQyxLQUFLLEVBQUUsQ0FBQyxDQUFDLElBQUksRUFBRSxJQUFJLEVBQUUsQ0FBQyxDQUFDLElBQUksRUFBQyxDQUFBO1FBQ3hDLENBQUMsQ0FBQyxDQUFBO0lBQ04sQ0FBQztJQUVELHNCQUFXLCtCQUFRO2FBQW5CO1lBQ0ksSUFBSSxJQUFJLEdBQUcsSUFBSSxDQUFDLElBQUksQ0FBQTtZQUNwQixJQUFJLFFBQVEsR0FBcUIsRUFBRSxDQUFBO1lBRW5DLFFBQVEsR0FBRyxJQUFJLENBQUMsUUFBUSxDQUFBO1lBU3hCLE9BQU8sUUFBUSxDQUFBO1FBQ25CLENBQUM7OztPQUFBO0lBRUQsc0JBQVcsNkJBQU07YUFBakI7WUFDSSxPQUFPO2dCQUNILEVBQUMsS0FBSyxFQUFFLE1BQU0sRUFBRSxJQUFJLEVBQUUsTUFBTSxFQUFDO2dCQUM3QixFQUFDLEtBQUssRUFBRSxRQUFRLEVBQUUsSUFBSSxFQUFFLFFBQVEsRUFBQzthQUNwQyxDQUFBO1FBQ0wsQ0FBQzs7O09BQUE7SUFDTCxnQkFBQztBQUFELENBQUMsQUFoQ0QsSUFnQ0M7QUFoQ1ksOEJBQVMifQ==